import gql from 'graphql-tag';

export default gql`
mutation SubmitReview(
        $app: String!,
        $rating: Int!,
        $review: String!
        ) {
    submitReview(input:{
        uuidApp: $app,
        rating: $rating,
        review: $review
    }) {
        __typename
    }
}
`;
